import { DataSet } from 'libs/end-to-end/src/types/databases/data-sets/data-set';

export const isCompositeDataSet = (dataSet: DataSet): boolean => {
  return dataSet.config.dataSetType === 'Composite';
};
